'use client';

import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Image } from '@/components/ui/Image';
import { TypographyH2, TypographyP } from '@/components/ui/typography';
import { cls } from '@/lib/utils';
import SectionBase from '@/components/ui/sections/section-base';
import SectionHeader from '@/components/ui/sections/section-header';
import {
  CRAIG_ALT,
  CRAIG_IMAGE_URL,
  JULIE_ALT,
  JULIE_IMAGE_URL,
  THE_BOYS_ALT,
  THE_BOYS_IMAGE_URL,
  THE_COOKS_ALT,
  THE_COOKS_IMAGE_URL,
} from './consts';

function About() {
  return (
    <>
      <SectionBase id="hero" background="bg-background">
        <SectionHeader
          subtitle="OUR TEAM"
          title="Meet the Cornerstone Homes Team"
          description="Since 2001, Craig, Julie, and the Cornerstone Homes family have been building custom homes and renovations across Claremore, OK and northeastern Oklahoma."
        />
      </SectionBase>

      {/* The Hays */}
      <SectionBase id="the-hays" background="bg-background">
        <Card
          className={cls`
            flex
            flex-col md:flex-row
            justify-start
            items-start
          `}
        >
          <CardHeader className="flex flex-1 md:p-10 md:pr-0">
            <TypographyH2>The Hays</TypographyH2>
            <TypographyP>
              Cornerstone started with Craig and Julie in 2001. While all
              4 of their children grew up going to work with mom and dad,
              a few now work for Cornerstone! Craig and Julie married in
              1994 and Abby the oldest was born in 1998, Lara in 2000,
              Annabelle in 2002, and Joe in 2005.
            </TypographyP>
          </CardHeader>

          <CardContent
            className={cls`
              flex
              flex-1
              flex-row
              gap-3
              md:self-stretch
              md:p-0
              w-full
              m-2
              md:m-6
            `}
          >
            <div className="relative flex-1 aspect-2/3">
              <Image
                priority
                fill
                className="rounded-lg"
                wrapperClassName="flex w-full h-full"
                src={CRAIG_IMAGE_URL}
                alt={CRAIG_ALT}
                sizes="(max-width: 768px) 50vw, 25vw"
                quality={100}
                style={{ objectFit: 'cover' }}
              />
            </div>
            <div className="relative flex-1 aspect-2/3">
              <Image
                fill
                className="rounded-lg"
                wrapperClassName="flex w-full h-full"
                src={JULIE_IMAGE_URL}
                alt={JULIE_ALT}
                sizes="(max-width: 768px) 50vw, 25vw"
                quality={100}
                style={{ objectFit: 'cover' }}
              />
            </div>
          </CardContent>
        </Card>
      </SectionBase>

      {/* The Cooks */}
      <SectionBase id="the-cooks" background="bg-card">
        <Card
          className={cls`
            flex
            flex-col
            justify-start
            items-start
            md:flex-row-reverse
          `}
          variant="transparent"
        >
          <CardHeader className="flex flex-1 md:p-10 md:pl-0">
            <TypographyH2>Abby</TypographyH2>
            <TypographyP>
              Abby is the face of Cornerstone Design. She drafts and designs
              floor plans for Cornerstone and other customers. However,
              Craig and Abby work together on Cornerstones plans to ensure a
              great house plan for customers. Craig brings the building
              experience and Abby brings fresh eyes, new ideas, and creative
              aspects to designing homes.
            </TypographyP>
          </CardHeader>

          <CardContent
            className={cls`
              flex
              flex-1
              flex-row
              md:self-stretch
              md:p-0
              relative
              aspect-4/3
              max-w-[calc(100vw-5rem)]
              w-full
              m-2
              md:m-6
            `}
          >
            <Image
              fill
              className="rounded-lg"
              wrapperClassName="flex w-full rounded-lg overflow-hidden"
              src={THE_COOKS_IMAGE_URL}
              alt={THE_COOKS_ALT}
              sizes="(max-width: 768px) 100vw, 50vw"
              quality={100}
            />
          </CardContent>
        </Card>
      </SectionBase>

      {/* The Boys */}
      <SectionBase id="the-boys" background="bg-background">
        <Card
          className={cls`
            flex
            flex-col
            justify-start
            items-start
            md:flex-row
          `}
          variant="secondary"
        >
          <CardHeader className="flex flex-1 md:p-10 md:pr-0">
            <TypographyH2>Project Superintendents</TypographyH2>
            <TypographyP>
              Jackson and Devin are Cornerstone&apos;s Project
              Superintendents. Devin has been with Cornerstone since 2018
              with Jackson joining in 2021. They oversee work being done on
              all aspects of every project from start to finish — the boots
              on the ground ensuring quality and progress every day.
            </TypographyP>
          </CardHeader>

          <CardContent
            className={cls`
              flex
              flex-1
              flex-row
              md:self-stretch
              md:p-0
              relative
              aspect-4/3
              max-w-[calc(100vw-5rem)]
              w-full
              m-2
              md:m-6
            `}
          >
            <Image
              fill
              className="rounded-lg"
              wrapperClassName="flex w-full"
              src={THE_BOYS_IMAGE_URL}
              alt={THE_BOYS_ALT}
              sizes="(max-width: 768px) 100vw, 50vw"
              quality={100}
            />
          </CardContent>
        </Card>
      </SectionBase>
    </>
  );
}

export default About;
